import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import logo from "./../../../../assets/img/logo/logo-white.png";
import weSupply from "./../../../../assets/img/logo/we-supply.png";

class SidebarHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
    };
  }

  componentDidMount() {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (user) {
      this.setState({ user });
    }
  }

  render() {
    const { menuShadow } = this.props;
    const { user } = this.state;

    return (
      <div className="navbar-header" style={{ height: "100px" }}>
        <ul className="nav navbar-nav flex-row">
          <li className="nav-item mr-auto" style={{ marginLeft: "auto" }}>
            <NavLink to="/home" className="navbar-brand">
              {user?.idCliente === 5 || user?.idCliente === 1 ? (
                <img src={weSupply} alt="We Supply" style={{ width: "100%", display: "none" }} />
              ) : (
                <img src={logo} alt="Logo" style={{ width: "100%", display: "none" }} />
              )}
            </NavLink>
          </li>
        </ul>
        <div
          className={classnames("shadow-bottom", {
            "d-none": menuShadow === false,
          })}
        />
      </div>
    );
  }
}

export default SidebarHeader;
